import { useTranslation } from 'libs/i18n';
import { IconButton, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import {
  Field,
  useFormContext,
} from 'modules/client/common/forms/taxResidencyForm';

interface Props {
  index: number;
  onRemoveTaxResidency?: (index: number) => void;
}

export const Header = ({ index, onRemoveTaxResidency }: Props) => {
  const { readOnly } = useFormContext();
  const { t } = useTranslation();
  const isFirst = index === 0;

  return (
    <Stack direction="row" spacing={12}>
      <Typography variant="bodyBold">
        {t(
          isFirst
            ? 'client.client.taxResidency.taxNumberTitle'
            : 'client.client.taxResidency.taxNumberTitleOther'
        )}
      </Typography>
      {!readOnly && (
        <>
          <Stack alignItems="center" direction="row" spacing={8}>
            <Typography variant="caption">
              {t('client.client.taxResidency.taxNumberIsMissing')}
            </Typography>

            <Field.Switch
              name={
                `taxResidences.${index}.taxNumberIsMissing` as 'taxResidences'
              }
            />
          </Stack>
          {onRemoveTaxResidency && !isFirst && (
            <IconButton
              colorVariant="red"
              icon={<Icon.Minus size={16} />}
              mode="outlined"
              sizeVariant="xs"
              onClick={() => onRemoveTaxResidency?.(index)}
            />
          )}
        </>
      )}
    </Stack>
  );
};
